import { HTMLProps, ReactNode } from 'react';

import { LoadingSpinner } from '@components/uiKit/LoadingSpinner';

import { scale, typography } from '@scripts/gds';
import { themeColor } from '@scripts/themes/cssVars';

export interface LoadWrapperProps extends HTMLProps<HTMLDivElement> {
    /** Wrapped component */
    children: ReactNode;
    /** Loading state */
    isLoading: boolean;
    /** Error text */
    error?: string | undefined;
    /** Empty result state */
    isEmpty?: boolean;
    /** Empty result text */
    emptyMessage?: ReactNode;
}

const LoadWrapper = ({ children, isLoading, error, isEmpty, emptyMessage, ...props }: LoadWrapperProps) => {
    return (
        <div
            {...props}
            css={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
            }}
        >
            {isLoading && <LoadingSpinner overlay />}
            {!isLoading && error && (
                <p
                    css={{
                        padding: `${scale(2)}px ${scale(3)}px 0`,
                        color: themeColor.danger,
                        ...typography('bodyMd'),
                    }}
                >
                    Ошибка: {error}
                </p>
            )}
            {!isLoading && !error && isEmpty && emptyMessage}
            {!isEmpty && children}
        </div>
    );
};

export default LoadWrapper;
